
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 18.334a8.11 8.11 0 01-3.25-.657 8.41 8.41 0 01-2.646-1.78 8.41 8.41 0 01-1.781-2.647A8.11 8.11 0 012.166 10a8.11 8.11 0 01.657-3.25 8.41 8.41 0 011.78-2.646A8.421 8.421 0 017.25 2.323a8.119 8.119 0 013.25-.656c1.153 0 2.236.219 3.25.656a8.421 8.421 0 012.646 1.781 8.41 8.41 0 011.781 2.646 8.11 8.11 0 01.657 3.25 8.11 8.11 0 01-.657 3.25 8.41 8.41 0 01-1.78 2.646 8.41 8.41 0 01-2.647 1.781 8.11 8.11 0 01-3.25.657zm4.166-10.417l1.125-.375.333-1.125a7.143 7.143 0 00-1.604-1.72 6.648 6.648 0 00-2.062-1.072l-1.125.792v1.167l3.333 2.333zm-8.333 0l3.333-2.333V4.417l-1.125-.792a6.648 6.648 0 00-2.062 1.073 7.144 7.144 0 00-1.605 1.719l.334 1.125 1.125.375zm-.875 6.417l.958-.084.625-1.125L5.833 9.5l-1.167-.416-.833.625c0 .902.125 1.725.375 2.468.25.743.666 1.462 1.25 2.157zm5.041 2.333a6.72 6.72 0 001.063-.083 6.447 6.447 0 001.02-.25l.584-1.25-.542-.917h-4.25l-.541.917.583 1.25c.333.11.674.194 1.02.25a6.72 6.72 0 001.063.083zM8.624 12.5h3.75l1.167-3.333-3.042-2.125-3 2.125L8.624 12.5zm6.917 1.834c.583-.695 1-1.414 1.25-2.157.25-.743.375-1.566.375-2.468l-.833-.584-1.167.375-1.208 3.625.625 1.125.958.084z","fill":"#fff","fill-opacity":".5"}})])
          )
        }
      }
    